import { BaseService, type ErrorsHandbook, HttpService } from '@/6_shared/api'
import { getMilliseconds } from '@/6_shared/lib'
import { SlideLocation, type SliderResponse } from '../model'
import { slideErrorsHandbook } from './error'

class SlideService extends BaseService {
  constructor(http: typeof HttpService, errorsHandbook: ErrorsHandbook) {
    super(http, errorsHandbook)
  }

  public getAll(slug: SlideLocation) {
    return this._http.get<SliderResponse>([slug, 'slider'].join('/'), {
      needCancelOnRouteChange: true,
      cacheConfig: {
        lifeTime: getMilliseconds.inHours(1)
      }
    })
  }
}

const slideService = new SlideService(HttpService, slideErrorsHandbook)

export { slideService }
